import { render, staticRenderFns } from "./BugReporter.vue?vue&type=template&id=808418a2"
import script from "./BugReporter.vue?vue&type=script&lang=js"
export * from "./BugReporter.vue?vue&type=script&lang=js"
import style0 from "./BugReporter.vue?vue&type=style&index=0&id=808418a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports